import axios from 'axios';
import axiosRetry from 'axios-retry';
import ENVS, { INITIAL_INDEX } from '@/modules/envs';

const { host, key } = ENVS.api[INITIAL_INDEX];
const defaultAxiosConfigs = {
  baseURL: host,
  timeout: 180000,
  headers: { 'X-Requested-With': 'XMLHttpRequest' },
  params: { apikey: key },
};
const retryCondition = (error) => {
  if (error.config.url.includes('feedbacks')) return false;
  const CODE_EXCLUDE_LIST = ['ERR_CANCELED'];
  const isNetworkError = !error.response &&
    Boolean(error.code) && // Prevents retrying cancelled requests
    !CODE_EXCLUDE_LIST.includes(error.code); // Prevents retrying timed out & cancelled requests
  const isRetryableError = error.code !== 'ECONNABORTED' && (!error.response);
  return isNetworkError || isRetryableError;
}
const mtm = axios.create(defaultAxiosConfigs);
const user = axios.create(defaultAxiosConfigs);
axiosRetry(mtm, { retries: 3, shouldResetTimeout: true, retryCondition });
axiosRetry(user, { retries: 3, shouldResetTimeout: true, retryCondition });

const onRequest = config => {
  console.log(`[Request] ${config.method.toUpperCase()} ${config.url} ${config['axios-retry'] != null ? `(retry-${config['axios-retry'].retryCount})` : ''}`);
  return config;
};

const success = res => {
  const { config, status } = res;

  // "axios-retry" repeatedly calls the callback with the same content, causing log noise, so it should be ignored.
  if (config && config['axios-retry'] && config['axios-retry'].retryCount > 0) {
    config['axios-retry'].retryCount -= 1;
    return res;
  }

  console.log(`[Response] ${config.method.toUpperCase()} ${status} ${config.url}`);
  return res;
};

const logError = err => {
  const { config, message, response } = err || {};
  const { url, method, data, headers, baseURL, params, timeout } = config || {};
  const { data: resp } = response || {};

  // "axios-retry" repeatedly calls the callback with the same content, causing log noise, so it should be ignored.
  if (config && config['axios-retry'] && config['axios-retry'].retryCount > 0) {
    config['axios-retry'].retryCount -= 1;
    return Promise.reject(err);
  }

  if (url.indexOf('/feedbacks') > -1) {
    console.log('Failed to send feedback');
  } else {
    console.log(
      '[ERROR]: ',
      message,
      resp || 'NO RESPONSE',
      `${method} ${url}`,
      params,
      data || 'NO DATA',
      headers,
      baseURL,
      timeout
    );
  }
  return Promise.reject(err);
};

mtm.interceptors.request.use(onRequest);
mtm.interceptors.response.use(success, logError);
user.interceptors.request.use(onRequest);
user.interceptors.response.use(success, logError);

const $api = {
  mtm,
  user,
};

export default $api;
